import {
	TTableStructure,
	ETableStructureType,
	ETableStructureAlign,
} from '../../../../../ui/EasTable/types';
import { EIconButtons } from '../../../../../ui/EasTable/EasTableRow/EasTableValue/constants';
import { TShopifyStoreShort } from '../../../../../redux/reducers/shopifyStores/types';

export type TShopifyStoresRow = TShopifyStoreShort & { id: number };

export const tableStructure: TTableStructure<keyof TShopifyStoresRow, TShopifyStoresRow>[] = [
	{
		name: 'link',
		selector: 'store_id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.LINK,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Store ID',
		selector: 'store_id',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Name',
		selector: 'name',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 2,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Store URL',
		selector: 'store_url',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 2,
		type: ETableStructureType.COPYABLE_TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Storefront URL',
		selector: 'store_front_url',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 2,
		type: ETableStructureType.COPYABLE_TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Enabled',
		selector: 'enabled',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Matched By',
		selector: 'matched_by',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Blocked At',
		selector: 'blocked_at',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Disabled At',
		selector: 'disabled_at',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		selector: 'actions',
		noName: true,
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.LEFT,
		buttons: [{ name: 'Edit', icon: EIconButtons.EDIT }],
	},
];
